import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  tabMap: { [key: string]: any };
  tab: {
    index: number;
    key: string;
  };
  onClickTab: (key: string, index: number) => void;
}

export const GeneralTab: React.FC<Props> = ({ tabMap, tab, onClickTab }) => {
  return (
    <Tab>
      {Object.keys(tabMap).map((key, index) => (
        <TabItem
          isSelected={key === tab.key}
          onClick={() => onClickTab(key, index)}
        >
          {key}
        </TabItem>
      ))}
    </Tab>
  );
};

const Tab = styled.div`
  position: relative;
  display: flex;
`;

interface TabItemProps {
  isSelected: boolean;
}

const TabItem = styled.div<TabItemProps>`
  margin-right: 1.5rem;
  cursor: pointer;
  color: ${(props) =>
    props.isSelected
      ? theme.palette.primitives.black
      : theme.palette.primitives.gray300};
  text-align: center;
  font-size: 1.313rem;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: ${(props) => (props.isSelected ? 600 : 400)};
  line-height: 1.563.rem;
`;

// interface SelectedTabProps {
//   index: number;
// }

// const SelectedTab = styled.span<SelectedTabProps>`
//   bottom: 0;
//   left: 0;
//   width: 90px;
//   height: 1px;
//   border-radius: 4px;
//   background-color: #1976d2;
// `;
